import { render } from "./AttributeCard.vue?vue&type=template&id=6ffa9aac&scoped=true"
import script from "./AttributeCard.vue?vue&type=script&lang=js"
export * from "./AttributeCard.vue?vue&type=script&lang=js"

import "./AttributeCard.vue?vue&type=style&index=0&id=6ffa9aac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ffa9aac"]])

export default __exports__